// @flow
import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import markSingleNotificationAsRead from '../state/markSingleNotificationAsRead';
import NotificationRouter from '../utilities/notificationRouter';
import {
    NOTIFICATION_FEED_TYPES,
    NOTIFICATION_TYPES_TO_CAL_DRAWER
} from '../constants';
import type { NotificationLookup } from '../constants';

type Props = {
    id: number,
    notificationsLookup: NotificationLookup,
    currentUser: {},
    teams: [],
    athletes: [],
    dispatch: () => any
};

const NotificationItem = ({
    id,
    notificationsLookup,
    currentUser,
    teams,
    athletes,
    dispatch
}: Props) => {
    const notification = notificationsLookup[id];
    const {
        isRead,
        actor,
        title,
        body,
        timestampCreated,
        type,
        metadata
    } = notification;
    const timeSinceCreation = moment.unix(timestampCreated).fromNow(true);

    const markAsRead = (id: number) => {
        if (isRead) {
            return;
        }

        dispatch(markSingleNotificationAsRead(id));
    };

    const isFeedRoutableItem = () => {
        if (!NOTIFICATION_FEED_TYPES.includes(type)) {
            return false;
        }

        for (let i = 0; i < teams.length; i++) {
            const team = teams[i];
            if (team.id === metadata.teamId) {
                return true;
            }
        }

        if (metadata.athleteId) {
            for (let i = 0; i < athletes.length; i++) {
                const athlete = athletes[i];
                if (athlete.id === metadata.athleteId) {
                    return true;
                }
            }
        }

        return false;
    };

    const isCalendarRoutableItem = () => {
        if (!NOTIFICATION_TYPES_TO_CAL_DRAWER.includes(type)) {
            return false;
        }

        const isTargetUserLoggedInCoach = currentUser.id === metadata.athleteId;

        if (metadata.athleteId) {
            return (
                NOTIFICATION_TYPES_TO_CAL_DRAWER.includes(type) &&
                !isTargetUserLoggedInCoach
            );
        }

        for (let i = 0; i < teams.length; i++) {
            const team = teams[i];
            if (team.id === metadata.teamId) {
                return true;
            }
        }

        return false;
    };

    const isItemRoutable = isFeedRoutableItem() || isCalendarRoutableItem();

    const handleNotificationRouting = (id: number) => {
        markAsRead(id);

        if (isItemRoutable) {
            NotificationRouter.route(type, notification);
        }
    };

    return (
        <li className="notification-item">
            <button
                className="notification-button"
                onClick={() => handleNotificationRouting(id)}
            >
                <div className="actor-avatar-container">
                    {!isRead ? <div className="unread-symbol" /> : null}
                    <img alt="Avatar" src={actor.imageProfile} />
                </div>
                <div className="notification-content">
                    <div className="notification-text">
                        <h2>{title}</h2>
                        <p className="body-content">{body}</p>
                        <p className="time-since-creation">
                            {timeSinceCreation}
                        </p>
                    </div>
                    {isItemRoutable && (
                        <div className="notification-action">
                            <KeyboardArrowRight className="notification-icon" />
                        </div>
                    )}
                </div>
            </button>
        </li>
    );
};

const mapStateToProps = (state: {}, ownProps: any) => {
    return {
        ...ownProps,
        notificationsLookup: state.notifications.notificationsLookup,
        currentUser: state.app.loggedInUser,
        teams: state.library.teamsTree,
        athletes: state.library.athletesTree
    };
};

export default connect(mapStateToProps)(NotificationItem);



// WEBPACK FOOTER //
// ./src/v5/notifications/components/NotificationItem.jsx